/**
 * Canvas Circle
 */
import CanvasParent from "./CanvasParent";
import canvTools from "./canvas-tools";
export default class CanvasCircle extends CanvasParent {

  type = 'circle';

  constructor(width, height, id) {
    super(width, height, id);
    document.addEventListener('click', this._clickCircle);
  }

  draw = () => {
    canvTools.drawCircle(this);
  }

  _clickCircle = (event) => {
    // if (this.mouseIn === false) return;
    if (this.clicked === false) {
      this.clicked = true;
      document.addEventListener('mousemove', this._listenDrawCircle);
      this.currentLine.start = [event.pageX - this.offsetLeft, event.pageY - this.offsetTop];
      this.findLimitRange(event);
    } else {
      this.clicked = false;
      this.valided = true;
      document.removeEventListener('click', this._clickCircle);
      document.removeEventListener('mousemove', this._listenDrawCircle);
      this.stopListenMouse();
    }
  }

  _listenDrawCircle = (event) => {
    let endX = event.pageX - this.offsetLeft;
    let endY = event.pageY - this.offsetTop;
    this.currentLine.end = [endX, endY];
    let {start, end} = this.currentLine;
    let radius = Math.sqrt(Math.pow((start[0] - end[0]), 2) + Math.pow((start[1] - end[1]), 2));
    if ((this.limitRange - radius) <= 3) {
      let startX = this.currentLine.start[0];
      let startY = this.currentLine.start[1];
      this.currentLine.end = [ startX + this.limitRange, startY]
    }
    this.positions[0] = this.currentLine;
    this.draw(this);
  }
}